<template>
    <!-- <div> -->
        <ul class="student">
            <li class="student-li flex-layout"
                v-for="(li,index) in list" 
                :key="index" 
                @click="getoDetail(li)">
                <img :src="li.urls"  :onerror="defaultImg" alt="" :style="imgSize" v-show="li.urls !== undefined">
                <div class="describe flex-column-between">
                    <h3 class="wes-2">{{li.title}}</h3>
                    <p class="wes-3">{{li.introduction}}</p>
                    <div class="flex-align-between other-info">
                        <span class="time">{{li.createTime}}</span>
                        <!-- <span class="eye">{{li.lookNum}}</span> -->
                    </div>
                </div>
            </li>
        </ul>
        <!-- TODO 加载更多 -->
    <!-- </div> -->
</template>

<script>
export default {
    props: {
        cloumn: {
          type:Number
        },
        // width:{
        //   type:Number
        // },
        imgWidth:{
            type:Number,

        },
        imgHeight:{
            type:Number,
 
        }
    },
    data() {
        return {
            
            defaultImg:require('../../../assets/yunqiao/win_item11.png'),
            
            // pWidth:{
            //     width: this.pWidth ? this.pWidth + 'px' : '277px',
            // },
            imgSize:{
                width: this.imgWidth ? this.imgWidth + 'px' : '253px',
                height: this.imgHeight ? this.imgSize + 'px' : '190px'
            },
            list:[{
                imgURL:'',
                name:'桂文娟桂文桂文桂文桂文桂文桂文桂文桂文文桂文桂文桂文桂',
                describe:'桂文娟，女，汉族，1969年10月出生，毕业于宁夏大学，现任灵武市回民中学语文学科教研组长，1989年7月参加工作，高级教师。在任教...',
                uplodeTime:'2020.06.21',
                lookNum:'1537'
            },{
                imgURL:'',
                name:'桂文娟',
                describe:'桂文娟，女，汉族，1969年10月出生，毕业于宁夏大月10月出生，毕业于宁夏大月出10月出生，毕业于宁夏大月出出生，月出生，月出生，月出生，学，现任灵武市回民中学语文学科教研组长，1989年7月参加工作，高级教师。在任教...',
                uplodeTime:'2020.06.21',
                lookNum:'1537'
            },{
                imgURL:'',
                name:'桂文娟',
                describe:'桂文娟，女，汉族，1969年10月出生，毕业于宁夏大学，现任灵武市回民中学语文学科教研组长，1989年7月参加工作，高级教师。在任教...',
                uplodeTime:'2020.06.21',
                lookNum:'1537'
            }],
        }
    },
    computed:{
        calcStyle:function() {
            let lof = 'u-lof'
            this.cloumn ? lof = 'u-lof' + String(this.cloumn) : ''
            return lof;
        }
    },
    methods: {
        async getArticleList(){
            let params = {
                type : 16,
                num:1,
                size:6,
                isAsc:'desc',
            }
            let resData = await Api.Home.getArticleList(params);
            resData.rows.forEach((item, index) => {
                 if(item.image !== undefined) {
                     item.urls = this.imageURL + item.image
                 } else {
                     item.urls = undefined;
                 }
            })
            // console.log(resData);
            this.list = resData.rows;
        },

        async getoDetail(item) {
            if(item.hasOwnProperty('url')) {
                window.open(item.url);
            } else {
            let msg = {id:item.articleId,type:item.type}
            this.$router.push('/list/information/detail/'+item.articleId ,msg)
            }
            // Common.goPage(this, '/news/work/'+item.articleId,msg)
        }
    },
    mounted() {
        this.getArticleList();
    }
}
</script>

<style lang="less" scoped>
    .student {
        flex-flow: row wrap;
        align-content: flex-start;

        .u-lof4 {
            flex: 0 0 24%;
        }

        .u-lof3 {
            flex: 0 0 33%;
        }

        .u-lof2 {
            flex: 0 0 49%;
        }

        .student-li {
            margin-bottom: 20px;
            cursor: pointer;

            img {
                display: inline-block;

                background-color: #1c4b90;
            }
            .describe {
                min-height: 120px;
                flex: 1;

                padding:20px 4px 10px 19px;;

                &:hover * {
                    color: #114dd7;
                }
                h3 {
                    // padding: 20px 0 0;

                    font-size: 20px;
                    font-weight: bold;

                    color: #333;
                }
                // p {
                //     flex-grow: 1;

                //     padding-top: 19px;
                // }
                p, span {
                    
                   font-size: 12px;

                   color: #999;
                }
                
                // .other-info {
                //     padding-bottom: 10px;
                // }

                span::before {
                    content: ' ';
                    display: inline-block;

                    margin-right: 4px;
                    width: 16px;
                    height: 12px;

                    background-repeat: no-repeat;
                }

                span.time::before {
                     background-image: url("../../../../static/news/time@2x.png");
                     background-size: 15px 15px;
                }

                span.eye::before {
                    background-image: url("../../../../static/news/eye@2x.png");
                    background-size: 16px 16px;
                }
            } 
        }
    }
  
</style>